import { Box, Tabs } from '@chakra-ui/react'
import VideoSwap from '@src/components/sco/InvestorOutreachLP/components/VideoSwap'
import { useBreakpointContext } from '@src/components/sco/utilities/BreakpointProvider'
import React from 'react'

const YouTubeVideoCarousel = () => {
  const { getBreakpointValue } = useBreakpointContext()

  const videos = [
    {
      url: 'https://www.youtube.com/watch?v=23ghmEZQ_Fc&t=279s&ab_channel=Startups.com%21',
      title: 'Video 1',
      coverImage: '/assets/graphics/investor-match/pdr-pre-seed-travel.webp',
    },
    {
      url: 'https://www.youtube.com/watch?v=2kTAwC6xnpE&ab_channel=Startups.com%21',
      title: 'Video 2',
      coverImage: '/assets/graphics/investor-match/pdr-cpg-health.webp',
    },
    {
      url: 'https://www.youtube.com/watch?v=-p818VvLzbc&t=190s&ab_channel=Startups.com%21',
      title: 'Video 3',
      coverImage: '/assets/graphics/investor-match/pdr-solar-power.webp',
    },
  ]

  return (
    <Tabs.Root defaultValue={'tab-0'} flex={2} height={'full'} variant={'plain'}>
      <>
        {videos.map((video, index) => (
          <Tabs.Content key={index} padding={0} value={`tab-${index}`}>
            <VideoSwap coverImage={video.coverImage} videoUrl={video.url} />
          </Tabs.Content>
        ))}
      </>
      <Tabs.List gap={2} marginTop={4} width={'full'}>
        {videos.map((video, index) => (
          <Tabs.Trigger
            key={index}
            _selected={{ opacity: 1, borderWidth: 2, borderColor: 'Gold' }}
            borderRadius={'lg'}
            boxShadow={'lg'}
            height={'full'}
            opacity={0.35}
            padding={0}
            value={`tab-${index}`}
            width={'full'}
          >
            <Box
              alignItems={'center'}
              aspectRatio={16 / 9}
              bgImage={`url(${video.coverImage})`}
              bgPos={'center'}
              bgRepeat={'no-repeat'}
              bgSize={'cover'}
              borderRadius={'lg'}
              display={'flex'}
              height={'full'}
              justifyContent={'center'}
              padding={6}
              width={'full'}
            />
          </Tabs.Trigger>
        ))}
      </Tabs.List>
    </Tabs.Root>
  )
}

export default YouTubeVideoCarousel
